import { render, staticRenderFns } from "./RmrNotice.vue?vue&type=template&id=7b047d0c&scoped=true&"
import script from "./RmrNotice.vue?vue&type=script&lang=js&"
export * from "./RmrNotice.vue?vue&type=script&lang=js&"
import style0 from "./RmrNotice.vue?vue&type=style&index=0&id=7b047d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b047d0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
